const joinCompanyRouter = 
{
    path: 'join-company-step',
    name: 'join-company-step',
    meta: {
      title: '加入单位'
    },
    redirect: {
        name: 'join-company-fillin'
    },
    component: () => import('@/components/router/Router'),
    children:[
    	{
    		path: 'fillin',
		    name: 'join-company-fillin',
		    meta: {
		      title: '完善资料-加入单位'
		    },
		    component: () => import('@/pages/index/joinCompany/Fillin.vue')
    	},
    	{
    		path: 'select',
		    name: 'join-company-select',
		    meta: {
		      title: '单位列表-加入单位'
		    },
		    component: () => import('@/pages/index/joinCompany/Select.vue')
    	},
    	{
    		path: 'approval',
		    name: 'join-company-approval',
		    meta: {
		      title: '等待审批-加入单位'
		    },
		    component: () => import('@/pages/index/joinCompany/Approval.vue')
    	},
        //迁移到了单位
        // {
        //     path: 'company-info/:id',
        //     name: 'join-company-info',
        //     meta: {
        //       title: '单位详情'
        //     },
        //     component: () => import('@/pages/index/joinCompany/CompanyInfo.vue')
        // },
        // {
        //     path: 'park/:companyType/:editType',
        //     name: 'join-company-park',
        //     meta: {
        //       title: '园区单位录入页'
        //     },
        //     component: () => import('@/pages/index/joinCompany/Park.vue')
        // },
        // {
        //     path: 'other/:companyType/:editType',
        //     name: 'join-company-other',
        //     meta: {
        //       title: '其他单位录入页'
        //     },
        //     component: () => import('@/pages/index/joinCompany/Other.vue')
        // },
    ]
};
export default joinCompanyRouter;


// WEBPACK FOOTER //
// ./src/router/index/joinCompany/joinCompany.js